"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const complex_plugin_1 = require("complex-plugin");
const antd_1 = require("complex-component/antd");
const litigation_1 = require("@/pages/index/select/litigation");
const MutipleForm_vue_1 = __importDefault(require("./MutipleForm.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'LitigationEdit',
    components: {
        MutipleForm: MutipleForm_vue_1.default,
        ComplexEditForm: antd_1.ComplexEditForm,
        ComplexAutoModal: antd_1.ComplexAutoModal
    },
    props: {
        mainData: {
            type: Object,
            required: true
        },
        flow: {
            type: Object,
            required: true
        },
        next: {
            type: Object,
            required: false
        },
        payload: {
            type: Object,
            default: () => ({})
        },
        refuse: {
            type: Boolean
        },
        disabled: {
            type: Boolean
        },
        info: {
            type: Boolean
        }
    },
    data() {
        return {
            isInit: false,
            currentFlowList: [],
            flowKey: undefined,
            detail: undefined
        };
    },
    computed: {
        isOperating() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        isStart() {
            return !this.flowKey || this.flowKey === this.flow.getBuild();
        },
        isDisabled() {
            return this.disabled || this.flowKey === this.flow.getEnd();
        },
        finishStatus() {
            return litigation_1.logStatus.getItem('100');
        }
    },
    methods: {
        init(flowKey, detail) {
            this.isInit = true;
            this.detail = detail;
            this.flowKey = flowKey;
            const editForm = this.$refs['edit-form'];
            editForm.initPageList = function () {
                this.mainList = this.dictionary.$getList(this.type, undefined, flowKey, true);
                const pageList = this.dictionary.$buildObserveList(this.type, this.mainList, {
                    mod: this.edit
                });
                this.pageList = pageList;
            };
            // eslint-disable-next-line no-console
            console.log('flowKey', flowKey);
            if (!this.flowKey) {
                editForm.show(this.flow.getBuild(), 'change', this.detail);
            }
            else {
                const flowList = this.flow.getList(this.flowKey);
                const index = flowList.indexOf(this.flowKey);
                this.currentFlowList = flowList.slice(index - 1, index);
                if (this.currentFlowList.length > 0) {
                    this.$refs['mutiple-form'].init();
                }
                editForm.show(this.flowKey, 'change', this.detail);
            }
        },
        onBack(toFrom) {
            this.$emit('back', toFrom);
        },
        onConfirm(operate, next) {
            complex_plugin_1.notice.confirm(`请确认是否进行${operate}操作？`, '警告', (act) => {
                if (act === 'ok') {
                    next();
                }
            });
        },
        onFinish() {
            const type = 'finish';
            this.$refs['finish-edit-modal'].show(this.finishStatus.label, type);
            this.$nextTick(() => {
                const editForm = this.$refs['finish-edit-form'];
                // editForm.initPageList = function() {
                //   this.mainList = (this.dictionary as any).$getList(this.type, undefined, type, true)
                //   const pageList = this.dictionary.$buildObserveList(this.type, this.mainList, {
                //     mod: this.edit
                //   })
                //   this.pageList = pageList
                // }
                editForm.show(type, 'change', this.detail);
            });
        },
        onEditMenu(act) {
            if (act === 'ok') {
                this.$refs['finish-edit-form'].handle((targetData, originData) => {
                    this.onConfirm(this.finishStatus.label, () => {
                        this.mainData.$triggerMethod('changeItem', [targetData, this.payload, originData, this.finishStatus], true).then(() => {
                            this.$refs['finish-edit-modal'].hide();
                            this.$emit('reload');
                        });
                    });
                });
            }
        },
        onSave() {
            this.$refs['edit-form'].handle((targetData, originData, type) => {
                this.onConfirm(this.next.label, () => {
                    if (type === this.flow.getBuild() && !this.flowKey) {
                        this.mainData.$triggerMethod('buildItem', [targetData, this.payload, originData, this.next], true).then(() => {
                            this.onBack();
                        });
                    }
                    else {
                        this.mainData.$triggerMethod('changeItem', [targetData, this.payload, originData, this.next], true).then(() => {
                            this.onBack();
                        });
                    }
                });
            });
        }
    }
});
